// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// Grab the root element from public/index.html
const rootElement = document.getElementById('root');

// Create a root using ReactDOM from 'react-dom/client'
const root = ReactDOM.createRoot(rootElement);

// Render your App wrapped in BrowserRouter
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
